module.exports = __webpack_public_path__ + "img/Pendjari 2.2d347c9d.jpg";